module.exports = __webpack_public_path__ + "img/CM-SL-24-Honda-Established.350c8f30.jpg";